import { EProblemReportStatus } from '@constants';
import { Flex, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';

interface Props {
  status: EProblemReportStatus;
  onClick?: (status: EProblemReportStatus) => void;
  isOpen?: boolean;
}

export const ProblemReportStatus: React.FC<Props> = ({ status, onClick, isOpen }) => {
  const { t } = useTranslation('ProblemReportsTranslations');

  const TYPES = {
    [EProblemReportStatus.NOT_REVIEWED]: 'error',
    [EProblemReportStatus.IN_REVIEW]: 'warning',
    [EProblemReportStatus.REVIEWED]: 'success'
  };

  return (
    <Tag
      color={TYPES[status]}
      style={{ cursor: 'pointer' }}
      onClick={() => {
        onClick?.(status);
      }}>
      <Flex align="center" gap={4}>
        {t(status)}
        {isOpen !== undefined && (
          <Icon i={isOpen ? 'CaretUp' : 'CaretDown'} color="black9" size={16} />
        )}
      </Flex>
    </Tag>
  );
};
